import React, { useEffect } from 'react'


import Card from '../common/card';
import {
    useQuery,
} from 'react-query'
import { fetchPosts, getCode } from '../../Services/codeMaster';

 const BlankPage = () => {

    // const { data } = useQuery('todoss', getCode)



    return (

        <>

            {/* <div className="row">
                    <div className="col text-center mb-5">
                        <a href="#" className="btn btn-outline-primary btn-rounded waves-effect add-btn float-right ml-auto float-right"
                            data-toggle="modal" data-target="#hello"><i className="fas fa-users" /> Hello Modal</a>
                        <button onClick={() => { window.$('#hello').modal('show') }}> click me </button>
                        <Modal id="hello"
                            iconClass="fas fa-users"
                            title="Hello Title"
                            okAction={() => { alert('closed') }} >
                            Hello world Body
                        </Modal>

                        <a href="revenue-management.html" class="btn btn-outline-primary btn-rounded waves-effect back-btn mr-auto float-left"><i class="fas fa-angle-double-left"></i> Back </a>
                        <h1 className="h1 d-inline-block m-auto">Dashboard</h1>


                    </div>
                </div> */}
            <div className="row">
                <h1 className="h1 d-inline-block m-auto">Dashboards</h1>
             
            </div>
            <div className="row">
                <Card icon="far fa-clock" title="Manage Alarm" size="2" redirect="/alarm" />
                <Card icon="fas fa-layer-group" title="Manage Device" size="2" redirect="/device" />
                <Card icon="fas fa-dumpster" title="Manage Product" size="2" redirect="/products" />
                <Card icon="fa fa-users" title="Manage Users" size="2"  redirect="/"/>
                <Card icon="fa fa-credit-card" title="Manage Cards" size="2"  redirect="/"/>
                <Card icon="fa fa-cogs" title="Manage Parts" size="2"   redirect="/"/>



            </div>
            <hr className="my-5" />
        </>


    )
}


export default BlankPage;